<template>
    <!-- <Link :href="href" :class="classes"> -->
    <a v-if="target==='_blank'" :href="href" target="_blank">
        <slot />
    </a>
    <Link v-else :href="href" >
        <slot />
    </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },

    props: ['href', 'active', 'target'],

    // computed: {
    //     classes() {
    //         return this.active
    //             ? 'text-pink-800 font-bold text-lg underline focus:outline-none transition duration-150 ease-in-out'
    //             : 'text-pink-800 font-bold text-lg hover:underline focus:outline-none transition duration-150 ease-in-out'
    //     }
    // }
}
</script>
